<template>
  <div class="login-card__success-card">
    <h1 class="login-card__title">{{ trans.get('auth.card.success.header') }}</h1>

    <div class="login-card__success-box">
      <i class="demo-icon icon-joker-out"></i>
    </div>

    <p class="login-card__desc"> {{ trans.get('auth.card.success.message') }}</p>

    <button
      type="button" @click="redirect"
      class="mt-3 button button__fill btn-block"
    >
      {{ trans.get('auth.card.buttons.continue') }}
    </button>

    <p class="login-card__title-desc" v-html="trans.get('auth.card.registration_agreement', {link1: zRoute('page.agbn'), link2: zRoute('page.privacy')})"></p>
  </div>
</template>
<script>
export default {
  props: {
    swapComponent: Function,
    timeout: {
      default: 5000,
    }
  },
  methods: {
    redirect() {
      window.location.href = zRoute('front.members.index');
    }
  },
  mounted() {
    if (this.timeout > 0)
      setTimeout(() => {
        this.redirect();
      }, this.timeout);
  },
};
</script>
<style scoped>
</style>
